import React from 'react';

import { Link, LinkProps } from '@chakra-ui/react';

import { EColor } from '../../../Theme/components/colors';

type HeaderNeutralLinkProps = {
  height?: string;
  onClick?: () => void;
} & Omit<LinkProps, 'onClick'>;

export const HeaderNeutralLink = ({
  children,
  href,
  height = '32px',
  onClick = () => {},
  ...props
}: HeaderNeutralLinkProps) => {
  return (
    <Link
      _active={{ bg: EColor.Neutral10, color: EColor.Black }}
      _disabled={{
        pointerEvents: 'none',
        opacity: '0.5',
        borderColor: EColor.Neutral45,
        bg: EColor.Neutral45,
      }}
      _focusVisible={{
        outline: 'none',
        ring: '2px',
        ringColor: EColor.Slate950,
        ringOffset: '2px',
      }}
      _hover={{ bg: EColor.Neutral5, color: EColor.Black }}
      alignItems="center"
      bg={EColor.White}
      border="1px"
      borderColor={EColor.Neutral150}
      borderRadius="full"
      color={EColor.Black}
      display="inline-flex"
      fontSize="12px"
      fontWeight="bold"
      height={height}
      href={href}
      justifyContent="center"
      px="12px"
      textTransform="capitalize"
      transition="colors"
      whiteSpace="nowrap"
      width="fit-content"
      onClick={onClick}
      {...props}
    >
      {children}
    </Link>
  );
};
